import React from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import M_Footer from './M_Footer';
import {Link} from 'react-router-dom';
import TopTitle from './TopTitle';
import queryString from 'query-string';

function Certification({history, location, match}) {

    const goBack = () => {
        history.goBack();
    };

    const query = queryString.parse(location.search);
    let cate = query.cate;
    console.log('cate ???? ', cate);

    const onClick = () => {
        history.push('/management?cate='+cate);
        
    }

  return (
    
    <>
    <TopTitle title="고객 인증코드"/>
    <Container>
        <div className="c_pad">
            <h5 className="font-weight-bold mb-3">인증 코드를 입력해주세요.</h5>
            <div className="c_flex c_boxshadow">
                <div className="col pr-0">
                    <input type="text" className="c_border" value="CSSE"/>
                </div>
                <div className="col">
                    <input type="text" className="c_border" value="PLZ2"/>
                </div>
                <div className="col pl-0">
                    <input type="text" className="c_border" value="MNDS"/>
                </div>
            </div>
            <div className="c_flex">
                <div className="c_certify my-3">인증번호를 - 없이 입력해주세요</div>
            </div>
            <div className="btn btn-primary c_coupon_btn" onClick={onClick}>쿠폰등록</div>
            <div>
                <span className="btn btn-primary r_btnsize mt-3" onClick={goBack}>뒤로가기</span>
            </div>
        </div>
        
    </Container>
    <M_Footer />
    </>
    
  );
}

export default Certification;